const AFFIRMATIONS = [
    "Famózne",
    "Spokojnosť",
    "Ide ti to",
    "Paráda",
    "Super",
    "Tešíme sa",
];

const COLORS = ["#2870ED", "#4EBC8D"];

export function ejectAffirmationParticle(btn) {
    const text  = AFFIRMATIONS[Math.floor(Math.random() * AFFIRMATIONS.length)];
    const color = COLORS[Math.floor(Math.random() * COLORS.length)];

    const rect = btn.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;

    const count = 3;
    for (let i = 0; i < count; i++) {
        const angle = (i / count) * 2 * Math.PI;
        const distance = 100 + Math.random() * 50;
        const tx = Math.cos(angle) * distance;
        const ty = Math.sin(angle) * distance;

        const el = document.createElement("div");
        el.textContent = text;
        el.style.cssText = `
          position: fixed;
          left: ${cx}px;
          top: ${cy}px;
          transform: translate(-50%, -50%);
          background: ${color};
          color: #fff;
          padding: 10px 24px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 700;
          pointer-events: none;
          z-index: 9999;
          white-space: nowrap;
        `;
        document.body.appendChild(el);

        el.animate(
            [
                { transform: "translate(-50%, -50%) translate(0, 0)", opacity: 1 },
                { transform: `translate(-50%, -50%) translate(${tx}px, ${ty}px)`, opacity: 0 },
            ],
            { duration: 2000, easing: "ease-out", fill: "forwards" }
        ).onfinish = () => el.remove();
    }
}
